import {css} from 'styled-components'

import {borderRadius} from '../cssConstants/decorations'
import {fontSizeSmall, fontSizeTiny} from '../cssConstants/typography'
import {spacingMedium, spacingTiny} from '../cssConstants/spacing'

const fontSizeHash = {
  small: fontSizeSmall,
  tiny: fontSizeTiny,
}

export const buttonMixin = css`
  display: inline-flex;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;
  border-radius: ${borderRadius};
  width: ${p => p.fluid && '100%'};

  transition-property: color, background-color, border-color, box-shadow;
  transition-duration: 0.3s;

  font-size: ${p => fontSizeHash[p.size]};

  padding: ${spacingTiny}rem ${spacingMedium}rem;

  &:focus,
  &:active:focus {
    outline: 0;
  }
`

export const icons = css`
  display: none;
  font-family: 'Material Icons';
`
